import { render, staticRenderFns } from "./BuilderMobileFrame.vue?vue&type=template&id=f6015658&scoped=true&"
import script from "./BuilderMobileFrame.vue?vue&type=script&lang=js&"
export * from "./BuilderMobileFrame.vue?vue&type=script&lang=js&"
import style0 from "./BuilderMobileFrame.vue?vue&type=style&index=0&id=f6015658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6015658",
  null
  
)

export default component.exports